import { Box, Button, Link, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  getServerError,
  PASSWORD_ERROR,
  SIGNIN_WITH_EMAIL_WRONG_EMAIL,
} from '../messages';
import { useState } from 'react';
import {
  APPLE_BLACK,
  DARK_GREY,
  DEEP_PURPLE,
  DEEP_PURPLE_HOVERED,
  DEEP_PURPLE_PRESSED,
  WHITE,
} from '../styles/colors';
import { apiRequest, setSession } from '../ApiClient';
import { SignUpWithApple } from '../Auth';
import { validateEmail, validatePassword } from '../utils';
import { Loader } from './Loader';

const styles = {
  input: {
    display: 'flex',
    '& .MuiFilledInput-root': {
      borderRadius: 0,
      color: DARK_GREY,
      background: WHITE,
      '&:hover': {
        '&::before': {
          border: 'none',
        },
        '&::after': {
          border: 'none',
        },
      },
      '&::before': {
        border: 'none',
      },
      '&::after': {
        border: 'none',
      },
    },
  },
  createAccountBtn: {
    width: '100%',
    maxWidth: '600px',
    padding: '15px 0',
    background: DEEP_PURPLE,
    borderRadius: '50px',
    boxShadow: 'none',
    fontSize: '12px',
    fontFamily: 'GeometriaExtraBold',
    fontWeight: 900,
    '&: hover': {
      background: DEEP_PURPLE_HOVERED,
    },
    '&:active': {
      background: DEEP_PURPLE_PRESSED,
    },
  },
  signInWithApple: {
    width: '100%',
    maxWidth: '600px',
    padding: '15px 0',
    background: APPLE_BLACK,
    borderRadius: '50px',
    boxShadow: 'none',
    fontSize: '12px',
    fontWeight: 900,
    fontFamily: 'GeometriaExtraBold',
    '&: hover': {
      background: APPLE_BLACK,
    },
  },
};
export const SignUp = ({ changeStep }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleChangeEmail = (e) => {
    setEmailError('');
    setEmail(e.target.value);
  };
  const handleChangePassword = (e) => {
    setPasswordError('');
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    if (!validateEmail(email)) {
      setEmailError(SIGNIN_WITH_EMAIL_WRONG_EMAIL);
    }
    if (!validatePassword(password)) {
      setPasswordError(PASSWORD_ERROR);
    }
    if (validatePassword(password) && validateEmail(email)) {
      setIsLoading(true);
      const resp = await apiRequest('/auth/signup', {
        email: email,
        password: password,
      });
      if (resp.ok) {
        window.fbq('track', 'CompleteRegistration');
        setSession(await resp.json());
        changeStep(e);
      } else {
        setEmailError(await getServerError(resp));
        setIsLoading(false);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit(event);
    }
  };

  return (
    <>
      <Box sx={{ mb: '20px', width: '100%' }}>
        <Typography
          sx={{ mb: '60px', fontWeight: 900 }}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Create a free
          <br />
          Funexpected account
        </Typography>
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& .MuiTextField-root': {
              mt: 1,
              mb: 1,
              width: '100%',
              maxWidth: '600px',
            },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            error={!!emailError}
            sx={styles.input}
            label="Email"
            variant="filled"
            type="email"
            value={email}
            helperText={emailError && emailError}
            onChange={handleChangeEmail}
            color="secondary"
          />
          <TextField
            error={!!passwordError}
            helperText={passwordError && passwordError}
            sx={styles.input}
            label="Password (6+ characters)"
            variant="filled"
            type="password"
            value={password}
            onChange={handleChangePassword}
            onKeyDown={handleKeyDown}
            color="secondary"
          />
          <Box
            sx={{
              width: '100%',
              maxWidth: '600px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              '& button': { m: 1 },
            }}
          >
            <Button
              sx={styles.createAccountBtn}
              onClick={handleSubmit}
              variant="contained"
            >
              Create Account
            </Button>
            {false && (
              <SignUpWithApple
                nextPath="/"
                render={(renderProps) => (
                  <Button
                    sx={styles.signInWithApple}
                    onClick={renderProps.onClick}
                    variant="contained"
                  >
                    Sign up with apple
                  </Button>
                )}
              />
            )}
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ opacity: 0.5, fontSize: '14px', textAlign: 'left' }}>
          By registering, you agree to our{' '}
          <Link
            color="inherit"
            href="https://funexpectedapps.com/terms"
            target="_blank"
          >
            Terms of Use
          </Link>{' '}
          and{' '}
          <Link
            color="inherit"
            href="https://funexpectedapps.com/privacy"
            target="_blank"
          >
            Privacy Policy
          </Link>
        </Typography>
      </Box>
      {isLoading && <Loader />}
    </>
  );
};

SignUp.propTypes = {
  changeStep: PropTypes.func,
};
